import type { UserRole } from '@mm/shared';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

export function homeForRole(role: UserRole): string {
  return role === 'STUDENT' ? '/app/my' : '/app';
}

export function RequireRole({ allow }: { allow: UserRole[] }) {
  const { user, loading } = useAuth();
  if (loading) return <p className="p-6 text-slate-500">Загрузка…</p>;
  if (!user) return <Navigate to="/app/login" replace />;
  if (!allow.includes(user.role)) return <Navigate to={homeForRole(user.role)} replace />;
  return <Outlet />;
}
